module.exports = __webpack_public_path__ + "media/kama.a69cd253.mp4";